import React from 'react';
//import i18next from 'i18next';
import { Icon, Checkbox } from 'semantic-ui-react';
import {
  nth,
  getPaymentStatus,
  paypalTotal,
  tcStatus,
  fullNameFromUserId,
  emailFromUserId
} from '../../../common/utils';
import { CSVLink } from 'react-csv';
import Papa from 'papaparse';
import { map, merge } from 'ramda';
import { generate } from 'shortid';


// https://github.com/react-tools/react-table#columns
export const getColumns = (onPaymentStatusChange, r) => {
  return [
    nth,
    {
      Header: 'Team name',
      accessor: 'name',
      maxWidth: 100,
      Footer: () => {
        const data = [];

        if (r) {
          let parsed = map(t => {
            return merge({
              event: t.event.title,
              code: t.competition.code,
              robotNumber: t.robotNumber,
              robotName: t.robotName,
              teamName: t.name,
              payment: getPaymentStatus(t)
            }, t.user);            
          }, r.getResolvedState().data || []);

          data.push(Papa.unparse(parsed));
        }


        return (
          <div>{map(d => {
            return (
              <CSVLink
                key={generate()}
                data={d}
                filename='teams'
                className='ui label'>
                <Icon name='download' />csv
              </CSVLink>
            );
          }, data)}</div>
        );
      }
    },
    {
      Header: 'Robot Name',
      accessor: 'robotName',
      maxWidth: 100
    },
    {
      Header: 'Robot #',
      accessor: 'robotNumber',
      maxWidth: 80,
      Cell: ({ original: o }) =>
        o.robotNumber ?  o.competition.code + '-' + o.robotNumber : ''
    },
    {
      id: 'memberCount',
      Header: () => <Icon name='user times'/>,
      accessor: row => row.members.length + '/' + (row.competition.teamMemberLimit || '-'),
      maxWidth: 40
    },
    fullNameFromUserId,
    emailFromUserId,
    {
      Header: 'Event',
      accessor: 'event.title',
      maxWidth: 200
    },
    {
      Header: 'Competition',
      accessor: 'competition.code',
      maxWidth: 100
    },
    {
      Header: 'Payment status',
      maxWidth: 180,
      id: 'paymentStatus',
      accessor: row => getPaymentStatus(row),
      Cell: ({ original }) => {
        const status = getPaymentStatus(original);

        if (['NOT_PAID', 'CONFIRMED', 'PO_SUBMITTED'].includes(status)) {
          return <Checkbox
                   toggle
                   user_id={original.userId}
                   team_id={original.teamId}
                   payment_id={(original.payments[0] || {}).paymentId}
                   checked={status === 'CONFIRMED'}
                   onChange={onPaymentStatusChange}
                   label={getPaymentStatus(original)}/>;
        } else {
          return status;
        }
      }
    },
    paypalTotal,
    tcStatus
  ];
};





export const DEFAULTSORTED = [
  { id: 'name', desc: false },
  { id: 'robotName', desc: false }
];

export const DEFAULTPAGESIZE = 20;



// WEBPACK FOOTER //
// ./src/private/admin/components/Teams/table.conf.js